var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.169,
    height: 31.17,
    viewBox: "0 0 31.169 31.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xls",
    transform: "translate(-3748.693 -1912.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1211",
    "data-name": "Group 1211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M3779.862,1922.357v17.39a4.421,4.421,0,0,1-4.419,4.42h-22.331a4.421,4.421,0,0,1-4.419-4.42v-22.33a4.421,4.421,0,0,1,4.419-4.42H3770.5Z",
    fill: "#1b612c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M3770.5,1917.937V1913l9.359,9.36h-4.94A4.421,4.421,0,0,1,3770.5,1917.937Z",
    fill: "#458d62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1212",
    "data-name": "Group 1212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M3756.958,1932.1l-2.228-6.055h1.978l1.136,3.9h.071l1.136-3.9h1.914l-2.236,6.063,2.236,6.135h-1.907l-1.157-3.921h-.122l-1.207,3.921h-1.842Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M3762.244,1926.049h1.849v10.741h2.521v1.457h-4.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M3767.314,1935.776a5.241,5.241,0,0,1,.046-.725c.031-.222.078-.461.139-.718h1.436v.593a5.475,5.475,0,0,0,.061.871,2.021,2.021,0,0,0,.2.64.959.959,0,0,0,.371.392,1.124,1.124,0,0,0,.568.133,1.069,1.069,0,0,0,.807-.29,1.172,1.172,0,0,0,.279-.846,3.262,3.262,0,0,0-.04-.525,2.178,2.178,0,0,0-.135-.475,3.355,3.355,0,0,0-.261-.5,6.753,6.753,0,0,0-.421-.583l-1.929-2.292a5.792,5.792,0,0,1-.793-1.325,3.674,3.674,0,0,1-.278-1.425,3.174,3.174,0,0,1,.189-1.114,2.5,2.5,0,0,1,.546-.875,2.44,2.44,0,0,1,.883-.571,3.259,3.259,0,0,1,1.189-.2,3.464,3.464,0,0,1,1.346.229,2.3,2.3,0,0,1,.861.6,2.18,2.18,0,0,1,.453.832,3.343,3.343,0,0,1,.132.924,4.089,4.089,0,0,1-.06.726q-.062.332-.139.731h-1.429v-.578a3.2,3.2,0,0,0-.279-1.489.953.953,0,0,0-.907-.518.987.987,0,0,0-.778.29,1.123,1.123,0,0,0-.257.775,2.509,2.509,0,0,0,.039.464,1.838,1.838,0,0,0,.114.382,2.162,2.162,0,0,0,.183.339c.071.11.152.224.242.343l2.15,2.6a7.434,7.434,0,0,1,.9,1.468,3.593,3.593,0,0,1,.314,1.488,3.2,3.2,0,0,1-.2,1.172,2.431,2.431,0,0,1-.582.885,2.576,2.576,0,0,1-.914.561,3.485,3.485,0,0,1-1.207.2,3.7,3.7,0,0,1-1.375-.221,2.309,2.309,0,0,1-.871-.585,2.088,2.088,0,0,1-.457-.829A3.453,3.453,0,0,1,3767.314,1935.776Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.187dc96cd337843d4a127069fbcbdc8b.svg";
export { ForwardRef as ReactComponent };